/**
 * Copyright © 2026 Adnuntius AS.
 */
import {Component, Input, OnChanges} from '@angular/core';

import {TARGETING_IMPORTS} from '../targeting-imports';

@Component({
  imports: TARGETING_IMPORTS,
  selector: 'adn-geospatial-targeting-summary',
  template: '{{data}} geospatial area{{data !== 1 ? "s" : ""}}'
})
export class GeospatialSummaryComponent implements OnChanges {
  @Input() targets: any;

  data = 0;

  ngOnChanges(): void {
    const oneTarget = (this.targets || [])[0] || {};
    this.data = ((oneTarget.definition && oneTarget.definition.geometries) || []).length;
  }
}
